<script lang="ts">
	import Footer from '../../../components/Footer.svelte';
	import NarrowInnerContainer from '@app/components/cms/layouts/NarrowInnerContainer.svelte';
	import HeaderBlog from '@app/components/blog/HeaderBlog.svelte';
	import { viewport } from '$lib/stores';

	export let data;

	let bottomNav = null;
	let bottomNavButtonMenuProps;
	let bottomNavButtonMenuPropsRef;

	$: bottomNavButtonMenuProps && (bottomNavButtonMenuPropsRef = bottomNavButtonMenuProps.ref);

	const loadBottomNav = async (): Promise<void> => {
		({ default: bottomNav } = await import('@app/components/nav/BottomNav.svelte'));
	};

	$: if ($viewport.isTablet || $viewport.isMobile) {
		loadBottomNav();
	} else {
		bottomNav = null;
	}
</script>

<main>
	{#if data && data.story}
		<HeaderBlog
			toggleSidebarRefs={[bottomNavButtonMenuPropsRef]}
			categoriesLinks={data.categoriesLinks}
		/>

		<section class=" cms-layout">
			{#if typeof data.story.subtitle === 'string'}
				<section>
					<div class="container">
						<NarrowInnerContainer>
							<h2 class="text-center">{data.story.subtitle}</h2>
						</NarrowInnerContainer>
					</div>
				</section>
			{/if}
			{#if data.story.desc}
				<section>
					<div class="container">
						<NarrowInnerContainer>
							<p class="font-display text-xl">{data.story.desc}</p>
						</NarrowInnerContainer>
					</div>
				</section>
			{/if}

			<slot />
		</section>
		<Footer classNames="mt-auto" />
		<svelte:component this={bottomNav} bind:bottomNavButtonMenuProps />
	{/if}
</main>
